<template>
  <div class="">
    <v-dialog
      class="popbox"
      name="dialog2"
      v-model="isShow"
      :title="dialogTitle"
      close-on-click-modal
      :modal="true"
      :width="668"
      @open="open"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      :showConfirm="false"
      :showCancel="false"
      append-to-body
    >
    <div class="model-text mb10">
        物模型是对设备在云端的功能描述，包括设备的属性、服务和事件。物联网平台通过定义一种物的描述语言来描述物模型，称之为 TSL（即 Thing Specification Language），采用 JSON 格式，您可以根据 TSL 组装上报设备的数据。您可以导出完整物模型，用于云端应用开发。
    </div>
    <div>
      <v-button class="" :type="button == 0 ? 'primary': 'info'" name="" @click="changeTSL(0)" >完整版</v-button>
      <v-button class="" :type="button == 1 ? 'primary': 'info'" name="" @click="changeTSL(1)" >精简版</v-button>
    </div>
    <div class="model-json">
        <json-viewer
          :value="jsonStr"
          :expand-depth="5"
          theme="my-awesome-json-theme"
          sort
          :show-array-index="false"
          copyable
        >

        </json-viewer>
    </div>
    </v-dialog>

  </div>
</template>

<script>
import JsonViewer from 'vue-json-viewer'
import '@/common/scss/my-awesome-json-theme.scss';
export default {
  components: {JsonViewer },
  props: {
    showInputDialog: {
      type: Boolean,
      default: false,
    },
    productKey: {},
  },
  data() {
    return {
      rules: {},
      ruleForm: {
        name: "",
        identifier: "",
        data_type: "",
      },

      dialogTitle: "查看物模型",
      button: 0,
      isShow: false,
      upTips: true,
      jsonStr:{},
      wholeUrl: '/td/td-iot-api/iot/product/thing/v1',
      reduceUrl: '/td/td-iot-api/iot/product/thing/simple/v1',
    };
  },
  created() {},
  watch: {
    showInputDialog(newVal) {
      this.isShow = newVal;
    },
  },
  methods: {
    changeTSL(sub){
      this.button = sub
      const URL = sub == 0 ? this.wholeUrl : this.reduceUrl
      this.getData(URL)
    },
    open(){
      this.changeTSL(0)
    },
    async getData(url) {
      const subData = {
        product_key: this.productKey,
        app_id: sessionStorage.getItem("appid") || "",
      };
      const res = await this.$getData(
        url,
        subData,
        false
      );
      if (res.code === 0) {
        this.jsonStr = res.data
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    handleConfirm() {
      this.$emit("update:showInputDialog", false);
    },
    handleAfterClose() {
      this.$emit("update:showInputDialog", false);
    },
  },
  beforeDestroy() {},
};
</script>

  <style lang="scss">
</style>
